"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeRLM = void 0;
function removeRLM(text) {
    return (text
        /* converts Right-to-left marks followed by persian characters to zero-width non-joiners (ZWNJ) */
        .replace(/([^a-zA-Z\-_])(\u200F)/g, "$1\u200c"));
}
exports.removeRLM = removeRLM;
